// A quantity at a position, typed the way the book prints it: "2", "2~3", or "As Required"
// (design doc §2.2). Staff copy from the page, so the editor accepts the page's notation.

export type FittedQuantity = { quantity_min: number; quantity_max: number };

/** "2" → 2..2, "2~3" (or "2-3") → 2..3. Null for anything else, including 0 and a backwards range. */
export function parseQuantity(input: string): FittedQuantity | null {
  const match = input.trim().match(/^(\d+)(?:\s*[~-]\s*(\d+))?$/);
  if (!match) return null;
  const min = Number(match[1]);
  const max = match[2] ? Number(match[2]) : min;
  return min >= 1 && max >= min ? { quantity_min: min, quantity_max: max } : null;
}

export function formatQuantity({ quantity_min, quantity_max }: FittedQuantity): string {
  return quantity_min === quantity_max ? String(quantity_min) : `${quantity_min}~${quantity_max}`;
}

/** What a customer reads for the quantity at a position: "2", "2~3", or "As required". */
export function describeQuantity(fitted: FittedQuantity & { optional: boolean }): string {
  return fitted.optional ? "As required" : formatQuantity(fitted);
}
